import './account-flow.sass';
import { Link, useNavigate } from 'react-router-dom';
// import logo from '../assets/logo/logo-no-background.png';
import logo from '../assets/logo-name-new.png';
// import logo from '../assets/UniFunn-Picart.png';
import { useState } from 'react';
import axios from 'axios';
import useAlert from '../hooks/useAlert';
import { useTranslation } from 'react-i18next';

const Signup = () => {
	const navigate = useNavigate();
	const { t, i18n } = useTranslation();
	const [form, setForm] = useState({
		email: '',
		password: '',
		confirmPassword: '',
	});

	const [account, setAccount] = useState({});
	// State for the initial verification popup after signup
	const [popup, setPopup] = useState(false);
	const [verificationCode, setVerificationCode] = useState('');

	// State for the new request verification code popup
	const [requestPopup, setRequestPopup] = useState(false);
	const [requestEmail, setRequestEmail] = useState('');


	const inputChange = (event, field) => {
		setForm({ ...form, [field]: event.target.value });
	}

	const { sendAlert } = useAlert();

	const checkForm = (event) => {
		event.preventDefault();
		let hasError = false;

		if (!form.email || !form.password || !form.confirmPassword) {
			sendAlert(t('account.signup_hint_all_required'));
			hasError = true;
		}

		if (form.password !== form.confirmPassword) {
			sendAlert(t('account.signup_hint_confirm_pw'));
			hasError = true;
		}

		if (!hasError) submitForm();
	}

	const submitForm = () => {
		axios.post('/user/create_user', {
			accountEmail: form.email,
			password: form.password,
		}).then((response) => {
			const message = response.data.message;
			const data = response.data.data;

			if (message === 'success') {
				// Show initial verification popup after successful signup
				setPopup(true);
				setAccount(data); // Store account info if needed for initial verification
			}
		}).catch((error) => {
			const message = error.response.data.message;

			switch (message) {
				case '[unique violation]: accountEmail must be unique':
					sendAlert(t('account.signup_hint_unique_email'));
					break;

				case '[Validation error]: Validation isEmail on accountEmail failed':
					sendAlert(t('account.signup_hint_invalid_email'));
					break;

				default:
					sendAlert('Oops!', message);
					break;
			}
		});
	}

	// Function to handle submission of the initial verification code popup
	const verifyEmail = (event) => {
		event.preventDefault();

		if (verificationCode) {
			axios.post('/user/auth/verification_code', {
				accountId: account.accountId,
				verifyCode: verificationCode,
			}).then((response) => {
				const message = response.data.message;

				if (message === 'This user is already authenticated') {
					sendAlert(t('account.signup_hint_verified'));
					setPopup(false); // Close initial popup
					navigate('/login'); // Redirect to login page
				} else if (message === 'success') {
					sendAlert(t('account.signup_hint_verified_success'));
					setPopup(false); // Close initial popup
					navigate('/login'); // Redirect to login page
				}
			}).catch((error) => {
				const message = error.response.data.message;

				switch (message) {
					case 'Verification code is not matched':
						sendAlert(t('account.signup_hint_wrong_code'));
						break;

					case 'Bad request':
						sendAlert('Bad request', message);
						break;

					default:
						sendAlert('Oops!', message);
						break;
				}
			});
		} else {
			// Handle case where verificationCode or accountId is missing
			sendAlert('請輸入驗證碼'); // Or a more specific message
		}
	}

	// Function to handle submission of the request verification code popup
	const requestVerificationCode = (event) => {
		event.preventDefault();

		if (requestEmail) {
			// Use URLSearchParams for form-encoded data
			const params = new URLSearchParams();
			params.append('accountEmail', requestEmail);

			axios.post('/user/auth/request_verification_code', params, {
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
			}).then((response) => {
				const message = response.data.message;
				const data = response.data.data;
				
				if (message === 'success') {
					sendAlert('驗證信已重新發送，請檢查您的信箱。'); // Success message
					setRequestPopup(false); // Close request popup
					setRequestEmail(''); // Clear email input

					setPopup(true);
					setAccount(data);
				} else {
					// Handle other potential success messages or unexpected responses
					sendAlert('Oops!', message);
				}
			}).catch((error) => {
				const message = error.response.data.message;

				switch (message) {
					case 'User not found':
						sendAlert('找不到相符的會員信箱。'); // User not found error
						break;
					case '[Validation error]: Validation isEmail on accountEmail failed':
						sendAlert(t('account.signup_hint_invalid_email')); // Invalid email format
						break;
					default:
						sendAlert('Oops!', message); // Generic error
						break;
				}
			});
		} 
		// else {
		// 	sendAlert('請輸入您的信箱地址。'); // Prompt for email input
		// }
	}


	return (
		<div id='Signup' className='account-flow'>
			<div className='wrap'>
				<div className='logo-wrap'>
					<Link to='/'>
						<img src={logo} alt='' />
					</Link>
				</div>

				<form className='form' onSubmit={checkForm}>
					<div className='form-title'>{t('account.signup_title')}</div>

					<div className='input-wrap'>
						<div className='label'>{t('account.login_email_title')}</div>
						<input type='email' value={form.email} onChange={(e) => { inputChange(e, 'email') }} />
					</div>

					<div className='input-wrap'>
						<div className='label'>{t('account.login_password_title')}</div>
						<input type='password' value={form.password} onChange={(e) => { inputChange(e, 'password') }} />
					</div>

					<div className='input-wrap'>
						<div className='label'>{t('account.signup_confirm_pw')}</div>
						<input type='password' value={form.confirmPassword} onChange={(e) => { inputChange(e, 'confirmPassword') }} />
					</div>

					<button className='button'>{t('account.signup_title')}</button>

					<div className='link-wrap'>
						<div className='text'>{t('account.signup_already_member')}</div>
						<Link to='/login'>{t('account.login_title')}</Link>

						
					</div>
					<div className='link-wrap'>
						{/* Link to open the new request verification code popup */}
						<div className='text'>需要重新發放驗證碼？</div>
						<a href="#" className='link' onClick={() => setRequestPopup(true)}>重新發送驗證信</a>
					</div>
				</form>
			</div>

			{/* Initial verification popup (shown after successful signup) */}
			<div className={`common-alert ${popup ? 'active' : ''}`}>
				<form className='center-wrap' onSubmit={verifyEmail}>
					<div className='title'>信箱驗證</div>
					<div className='message'>驗證碼已寄到您的註冊信箱，<br />請立即完成信箱驗證。</div>
					<div className='message'>請輸入您的驗證碼</div>
					<div className='button-wrap'>
						<input type='text' onChange={(e) => {
							setVerificationCode(e.target.value);
						}} value={verificationCode} />
					</div>
					<div className='button-wrap'>
						<button className='button'>確定</button>
					</div>
				</form>
			</div>

			{/* New request verification code popup */}
			<div className={`common-alert ${requestPopup ? 'active' : ''}`}>
				<form className='center-wrap' onSubmit={requestVerificationCode}>
					{/* Add a close button */}
					<button
						className='close-button'
						onClick={() => setRequestPopup(false)}
						style={{
							position: 'absolute',
							top: '8px',
							right: '18px',
							background: 'none',
							border: 'none',
							fontSize: '2em',
							cursor: 'pointer',
							padding: '5px',
							color: '#333',
							fontWeight: 'bold'
						}}
					>
						&times;
					</button>
					
					<div className='title'>重新發送驗證信</div>
					<div className='message'>請輸入您的註冊信箱地址，我們將重新發送驗證碼。</div>
					<div className='button-wrap'>
						<input
							type='email'
							placeholder='請輸入信箱' // Placeholder text
							value={requestEmail}
							onChange={(e) => setRequestEmail(e.target.value)}
						/>
					</div>
					<div className='button-wrap'>
						<button className='button'>發送驗證信</button>
					</div>
					
				</form>
			</div>
		</div>
	)
}

export default Signup;